import type { FrontendPlugin } from "@backstage/frontend-plugin-api";
import { createFrontendPlugin } from "@backstage/frontend-plugin-api";

import { securityInsightsApi } from "./apis";
import {
    groupSecurityContent,
    securityInsightsContent,
    securityInsightsEntityCard,
} from "./entityContents";

const securityInsightsPlugin: FrontendPlugin = createFrontendPlugin({
    pluginId: "security-insights",
    extensions: [
        securityInsightsApi,
        securityInsightsContent,
        groupSecurityContent,
        securityInsightsEntityCard,
    ],
});

export default securityInsightsPlugin;
